"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionModule = void 0;
/**
 * Generates the module code for a template of type function.
 *
 * Doesn't do much since we already have a js function, just some cleanup...
 */
class FunctionModule {
    generateModule(jsCode) {
        return jsCode;
    }
}
exports.FunctionModule = FunctionModule;
//# sourceMappingURL=function_module.js.map